import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContactComponent } from "./contact.component";
import { ControlsModule } from "src/app/controls/controls.module";
import { TablerIconComponent } from "angular-tabler-icons";

@NgModule({
  declarations: [
    ContactComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    TablerIconComponent
  ],
  exports: [
    ContactComponent
  ]
})
export class ContactModule { }